/** Library for image assets */
export const images = {
  MNOHSLogo: require('./MNOHS_logo.png'),
  hamburgerMenu: require('./hamburger_menu.png'),
  bellIcon: require('./bell_icon.png'),
  cameraIcon: require('./camera_icon.png'),
  caretDownIcon: require('./carrot_icon.png'),
  caretUpIcon: require('./caret_up_icon.png'),
  caretLeftIcon: require('./caret_left_icon.png'),
  caretRightIcon: require('./caret_right_icon.png'),
  notificationIcon: require('./notification-icon.png'),
  notificationActiveIcon: require('./notification-active-icon.png'),
  chevronLeft: require('./arrow-drop-left-line.png'),
  chevronRight: require('./arrow-drop-right-line.png'),
  pencilIcon: require('./pencil_icon.png'),
  searchIcon: require('./search-line.png'),
  xIcon: require('./x_icon.png'),
  profilePhotoPlaceholder: require('./profile_photo_placeholder.png'),
  uploadIcon: require('./upload-icon.png'),
};
